import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const image11MMASquareRaw = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: 'mma_1x1',
  className: 'mma_1x1',
  aspectRatio: 1,
  type: 'Image1x1',
  associationType: 'SquareImageMedia',
  imagePreviewHeight: 400,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [470, 470],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Square image'),
    stringKey: _TL_('1:1'),
  },
  previewSettings: {
    showAdsLabel: true,
    showImage: true,
    showDescription: true,
    showShortHeadline: true,
    showAdditionalDisclaimer: true,
    showAction: true,
    showUrl: true,
    showGradient: true,
    showUrlMultiline: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    description: {
      color: 'white',
      bottom: 8,
      fontSize: 14,
      position: 'relative',
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
      height: 400,
      width: 400,
    },
    shortHeadline: {
      color: 'white',
      bottom: 20,
      position: 'relative',
      fontSize: 24,
      fontWeight: 200,
      paddingBottom: 5,
    },
    finalUrl: {
      color: 'green',
      fontSize: 10,
      bottom: 18,
      position: 'relative',
    },
    textContainer: {
      left: 0,
      position: 'absolute',
      lineHeight: 1.1,
      paddingLeft: 32,
      bottom: 25,
      fontSize: 10,
    },
    gradient: {
      backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
      width: '100%',
      height: 400,
      display: 'block',
      position: 'absolute',
    },
    actionButton: {
      padding: '6px 16px 8px 16px',
      position: 'relative',
    },
  },
};

export default image11MMASquareRaw;
